import http from '../../../../../libs/http'
export default (id, payload = {}) => http.put(`${process.env.VUE_APP_MICROSERVICE_API_PUBLICACIONES}/${id}`, payload, { loading: true })
